<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
    <v-layout column right floating class="fab-container" style="z-index: 1">
      <v-btn v-if="$userPermission.hasPermission('ROLE_ACCESO_ENVIAR_EMAILB')" color="primary" fab small dark :title="$t('view.bases.base.button.email')" class="btn_tippy_menu mb-1" @click="email">
        <v-icon small>fas fa-envelope</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";
import { TIPO_IMPORT_BASE_SELECT, TIPO_CONTACTO_SELECT, STATUS_BASE_SELECT } from "@/constants/operativos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        subtipo: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , tipo: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , vendor: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , status: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        subtipo: []
        , payfac: []
        , fecha: []
        , tipo: []
        , vendor: []
        , status: []
      }
      , options: [
        {
          code: "subtipo"
          , name: this.$t("view.bases.base.filters.subtipo")
          , icon: "fas fa-sort-numeric-down"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "payfac"
          , name: this.$t("view.bases.base.filters.payfac")
          , icon: "fas fa-credit-card"
          , type: "sino"
          , selected: false
          , disabled: false
        }
        , {
          code: "fecha"
          , name: this.$t("view.bases.base.filters.fecha")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "tipo"
          , name: this.$t("view.bases.base.filters.tipo")
          , icon: "fas fa-clipboard-list"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "vendor"
          , name: this.$t("view.bases.base.filters.vendor")
          , icon: "fas fa-hand-holding-usd"
          , type: "select"
          , selected: {}
          , disabled: this.$store.getters.getUserData.tipoUsuario != "ADMINISTRADOR"
        }
        , {
          code: "status"
          , name: this.$t("view.bases.base.filters.status")
          , icon: "fas fa-check"
          , type: "select"
          , selected: {}
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectSubTipo();
        this.loadSelectTipo();
        this.loadSelectVendor();
        this.loadSelectStatus();

        if (this.select.vendor.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectSubTipo() {
      this.select.subtipo.filteredList = TIPO_IMPORT_BASE_SELECT || [];
      this.select.subtipo.completeList = TIPO_IMPORT_BASE_SELECT || [];
    }
    , async loadSelectTipo() {
      this.select.tipo.filteredList = TIPO_CONTACTO_SELECT || [];
      this.select.tipo.completeList = TIPO_CONTACTO_SELECT || [];
    }
    , async loadSelectVendor() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.select.vendor.filteredList = vendorList || [];
      this.select.vendor.completeList = vendorList || [];
    }
    , async loadSelectStatus() {
      this.select.status.filteredList = STATUS_BASE_SELECT || [];
      this.select.status.completeList = STATUS_BASE_SELECT || [];
    }
    , email() {
      this.$emit("email");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/bases/base/Filters.vue